var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoonbeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-symbol",
    transform: "translate(-83 -294)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37",
    "data-name": "Rectangle 37",
    width: 200,
    height: 200,
    transform: "translate(83 294)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "symbol",
    transform: "translate(-224.332 64.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M808.276,400.23A61.3,61.3,0,0,0,747,461.543h0c0,.043,0,.084,0,.128l0,.1a3.016,3.016,0,0,0,3.017,2.845H866.534a3.015,3.015,0,0,0,3.016-2.845l.005-.1c0-.044,0-.085,0-.128h0A61.3,61.3,0,0,0,808.276,400.23Z",
    transform: "translate(-382.261 -154.395)",
    fill: "#53cbc8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M673.015,617.7a3.729,3.729,0,1,1-3.73-3.732A3.73,3.73,0,0,1,673.015,617.7Z",
    transform: "translate(-348.846 -242.095)",
    fill: "#e1147b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M853.29,585.287H728.267a3.677,3.677,0,0,0-3.231,5.423c.02.039.041.078.062.116a3.668,3.668,0,0,0,3.232,1.924h124.9a3.669,3.669,0,0,0,3.232-1.924l.062-.116A3.678,3.678,0,0,0,853.29,585.287Z",
    transform: "translate(-373.07 -230.326)",
    fill: "#e1147b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M869.9,527.924H728.262a3.681,3.681,0,0,0-3.666,3.887c0,.039,0,.078.006.117a3.665,3.665,0,0,0,3.667,3.459H869.9a3.666,3.666,0,0,0,3.667-3.459c0-.039,0-.078.006-.117A3.681,3.681,0,0,0,869.9,527.924Z",
    transform: "translate(-373.068 -206.789)",
    fill: "#e1147b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M833.6,671.331H769.767a3.675,3.675,0,0,0-1.638,6.964l.234.117a3.657,3.657,0,0,0,1.637.382h63.364a3.662,3.662,0,0,0,1.638-.382l.233-.117A3.675,3.675,0,0,0,833.6,671.331Z",
    transform: "translate(-390.097 -265.632)",
    fill: "#e1147b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M899.737,642.649H835.906a3.676,3.676,0,0,0-1.637,6.964l.233.117a3.668,3.668,0,0,0,1.638.381H899.5a3.665,3.665,0,0,0,1.638-.381l.233-.117A3.676,3.676,0,0,0,899.737,642.649Z",
    transform: "translate(-417.236 -253.863)",
    fill: "#e1147b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    d: "M798.341,620.256l-.108-.116a3.674,3.674,0,0,1,2.694-6.173h103.6a3.674,3.674,0,0,1,2.694,6.173l-.108.116a3.7,3.7,0,0,1-2.693,1.174H801.034A3.7,3.7,0,0,1,798.341,620.256Z",
    transform: "translate(-402.878 -242.095)",
    fill: "#e1147b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M691.913,613.968h49.472a3.676,3.676,0,0,1,1.637,6.964l-.233.117a3.657,3.657,0,0,1-1.637.382h-49a3.658,3.658,0,0,1-1.638-.382l-.233-.117A3.676,3.676,0,0,1,691.913,613.968Z",
    transform: "translate(-358.154 -242.095)",
    fill: "#e1147b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M709.367,531.655a3.729,3.729,0,1,1-3.73-3.731A3.73,3.73,0,0,1,709.367,531.655Z",
    transform: "translate(-363.763 -206.789)",
    fill: "#e1147b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M786.534,561.345c.01-.038.02-.078.031-.116a3.672,3.672,0,0,0-3.549-4.622H679.4a3.671,3.671,0,0,0-3.549,4.622c.01.038.021.078.032.116a3.681,3.681,0,0,0,3.547,2.724H782.986a3.683,3.683,0,0,0,3.548-2.724",
    transform: "translate(-353.019 -218.558)",
    fill: "#e1147b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    d: "M660.5,560.337a3.729,3.729,0,1,1-3.729-3.731A3.731,3.731,0,0,1,660.5,560.337Z",
    transform: "translate(-343.711 -218.558)",
    fill: "#e1147b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    "data-name": "Path 196",
    d: "M709.367,589.018a3.729,3.729,0,1,1-3.73-3.731A3.731,3.731,0,0,1,709.367,589.018Z",
    transform: "translate(-363.763 -230.326)",
    fill: "#e1147b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    "data-name": "Path 197",
    d: "M817.008,646.381a3.729,3.729,0,1,1-3.73-3.731A3.73,3.73,0,0,1,817.008,646.381Z",
    transform: "translate(-407.928 -253.863)",
    fill: "#e1147b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    d: "M750.868,675.063a3.729,3.729,0,1,1-3.729-3.731A3.73,3.73,0,0,1,750.868,675.063Z",
    transform: "translate(-380.79 -265.632)",
    fill: "#e1147b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonbeam);
export default __webpack_public_path__ + "static/media/moonbeam.d537e3282e2645ee2f1df9f7c3711f5a.svg";
export { ForwardRef as ReactComponent };